import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ThreedotsIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 16} height={height || 4} viewBox="0 0 16 4">
      <path
        data-name="Path 929"
        d="M6 10a2 2 0 102 2 2.006 2.006 0 00-2-2zm12 0a2 2 0 102 2 2.006 2.006 0 00-2-2zm-6 0a2 2 0 102 2 2.006 2.006 0 00-2-2z"
        transform="translate(-7 -13) translate(3 3)"
        fill={color || "#868482"}
      />
    </svg>
  );
}
